import { FC, useEffect, useState } from 'react';
import { DialogBase, DialogProps } from '../../../../components/dialogs';
import { Box, Button, Stack, Typography } from '@mui/material';
import { useFiles } from '../../../files';
import { FileUpload } from '../../components/FileUpload';
import { useTranslation } from 'react-i18next';
import { IWantedListResponse } from '../../models';

interface IWantedListNationaDialogProps extends DialogProps {
  handleValid: (values: any) => void;
  list: IWantedListResponse[];
}

enum WantedListNationalTypeEnums {
  ALQAEDA = 'alQaeda',
  TALIBAN = 'Taliban',
  DPRK = 'DPRK',
  IRAN = 'Iran',
}

export const WantedListInternationalDialog: FC<IWantedListNationaDialogProps> = ({
  handleValid,
  list,
  ...props
}) => {
  const [files, setFiles] = useState<any>({});
  const { handleInputUpload } = useFiles();
  const { t } = useTranslation();

  // const handleDelete = (type: string) => {
  //   setFiles((prev: any) => ({ ...prev, [type]: null }));
  // };

  const handleDelete = (type: string) => {
    const shape = type.split('.')[0];
    const lang = type.split('.')[1];
    setFiles((prev: any) => ({ ...prev, [shape]: { ...prev[shape], [lang]: null } }));
  };
  // const handleChangeInput = async (e: any, type: string) => {
  //   if (!e.target.files?.length) return;

  //   const res = await handleInputUpload(e);
  //   setFiles((prev: any) => ({ ...prev, [type]: res }));
  // };
  const handleChangeInput = async (e: any, type: string) => {
    if (!e.target.files?.length) return;
    const title = type.split('.')[0];
    const fileType = type.split('.')[1];

    const res = await handleInputUpload(e);
    setFiles((prev: any) => ({ ...prev, [title]: { ...prev?.[title], [fileType]: res } }));
  };

  useEffect(() => {
    if (list) {
      setFiles(list[0]?.files);
    }
  }, [list]);
  return (
    <DialogBase {...props} maxWidth="md" fullWidth>
      <Box
        component="form"
        onSubmit={(e) => {
          e.preventDefault();
          handleValid(files);
        }}
      >
        <Stack direction="row" gap={2}>
          <Stack gap={2}>
            <Typography textAlign="center">Pdf (format)</Typography>
            {Object.values(WantedListNationalTypeEnums).map((item) => (
              <FileUpload
                acceptedFiles=".pdf"
                key={item}
                currentName={files?.[item]?.['pdf']?.saved_name}
                handleChangeInput={(e: any) => handleChangeInput(e, `${item}.pdf`)}
                handleDelete={(item) => handleDelete(`${item}.pdf`)}
                item={item}
              />
            ))}
          </Stack>
          <Stack gap={2}>
            <Typography textAlign="center">Xml (format)</Typography>
            {Object.values(WantedListNationalTypeEnums).map((item) => (
              <FileUpload
                acceptedFiles=".xml"
                key={item}
                currentName={files?.[item]?.['xml']?.saved_name}
                handleChangeInput={(e: any) => handleChangeInput(e, `${item}.xml`)}
                handleDelete={(item) => handleDelete(`${item}.xml`)}
                item={item}
              />
            ))}
          </Stack>
        </Stack>
        <Button
          sx={{ marginLeft: 'auto', display: 'block', mt: 2 }}
          variant="contained"
          type="submit"
          color="primary"
        >
          {t('action.save')}
        </Button>
      </Box>
    </DialogBase>
  );
};
